module.exports = __webpack_public_path__ + "img/57.e4f42f8a.png";